// 对现有的数据进行【模糊搜索】
// 支持小写搜索

/**
 * @text 搜索文本
 * @field 需要搜索的字段名
 * @data 搜索数据 也就是说在这个范围内搜索
 */
export default function(text,field,data=[]){
    text=text.toLowerCase();
    const result=[];
    data.forEach(item=>{
        const value=item[field].toLowerCase();
        if(value.indexOf(text)!==-1)
            result.push(item);
    });
    return result;
    
}